import {createTimeoutContext} from "../utils/context.js";

let callbackCounter = 1;
const URL_SCHEMES = window.JSBRIDGE_SCHEMES || "mm-chat";
const BRIDGET_CALL_TIMEOUT = window.JSBRIDGE_DEFAULT_TIMEOUT || 1000;

function isBizChatApp() {
    const rule = /bizchat/i;
    return rule.test(window.navigator.userAgent);
}

function getCallbackName() {
    return `JSBridgeCallback${callbackCounter++}`;
}

/**
 * @param {string} globalCallbackName
 * @param {function} callback
 */
function generateCallback(globalCallbackName, callback) {
    const cb = (args) => {
        console.log(`jsbridge callback \\n${JSON.stringify(args, null, 4)}`);
        callback(args);

        delete window[globalCallbackName];
    };
    window[globalCallbackName] = cb;
    return cb;
}

/**
 *
 * @param {string} uri
 * @param {object} params
 * @returns {Promise<*>}
 */
function call(uri, params = {}) {
    if (!isBizChatApp()) {
        if (!window.showBizChatRuntimeError) {
            window.showBizChatRuntimeError = true;
            return Promise.reject(new Error("not in bizChat runtime"));
        }
        return Promise.resolve();
    }
    return (new Promise((resolve) => {
        const globalCallbackName = getCallbackName();

        generateCallback(globalCallbackName, resolve)

        const query = new URLSearchParams();
        Object.entries(params).forEach(([key, value]) => {
            query.set(key, value);
        });
        query.set('callback', globalCallbackName);

        const iframe = document.createElement("iframe");
        iframe.id = globalCallbackName;
        iframe.style.display = 'none';
        iframe.src = `${URL_SCHEMES}://api/${uri}?${query.toString()}`;

        console.log(`jsbridge get ${iframe.src}`);
        document.documentElement.appendChild(iframe);
    }))
        .then((data) => {
            if (data.status) {
                return Promise.resolve(data.data);
            }

            if (data.error) {
                return Promise.reject(data.error);
            }

            return Promise.reject();
        });
}

export default {
    /**
     * 获取 FCM token
     * @param timeout
     * @returns {Promise<* | boolean>}
     */
    getFCMToken(timeout = BRIDGET_CALL_TIMEOUT) {
        return createTimeoutContext(() => {
            return call(`fcm/token`)
                .then((data) => {
                    return Promise.resolve(data.token);
                })
        }, timeout)
            .catch(() => {
                if (window.FAKE_FCM_TOKEN) {
                    return Promise.resolve(window.FAKE_FCM_TOKEN);
                }
            })
    },
    /**
     * 打开新webview
     *
     * @param url
     * @returns {Promise<unknown>}
     */
    webOpen(url) {
        return new Promise((resolve => {
            call(`web/open`, {url});

            resolve();
        }));
    },

    /**
     * 打开新 browser
     *
     * @param url
     * @returns {Promise<unknown>}
     */
    browserOpen(url) {
        return new Promise((resolve => {
            call(`browser/open`, {url});

            resolve();
        }));
    },

    /**
     * 设置 App 小红点计数
     *
     * @param badge
     * @returns {Promise<*>}
     */
    setBadge(badge = 0) {
        return call(`badge`, {badge});
    },

    /**
     * 获取App 打包信息
     *
     * @param timeout
     * @returns {Promise<*>}
     */
    getPKGInfo(timeout = BRIDGET_CALL_TIMEOUT) {
        return createTimeoutContext(() => {
            return call(`pkginfo`)
        }, timeout);
    },
}
